import { render, staticRenderFns } from "./ClientAccess.vue?vue&type=template&id=2babc554&"
import script from "./ClientAccess.vue?vue&type=script&lang=js&"
export * from "./ClientAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports